import { useParams } from "react-router-dom";
import { SupportPageContentContainer, SupportArticleContainer } from "@platform/features/support";

export function DashboardSupportArticlePage() {
  const { id: programId, articleId } = useParams<{ id: string; articleId: string }>();

  return (
    <SupportPageContentContainer articleId={articleId} programId={programId} isArticlePage>
      <SupportArticleContainer
        articleId={articleId}
        programId={programId}
        className="px-4 pr-4 md:px-0 md:pr-8"
      />
    </SupportPageContentContainer>
  );
}

export default DashboardSupportArticlePage;


